
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"mod-newsList-box\">\n\n            <!-- <div class=\"p-numTips\">\n                <p class=\"txt\">\n                    <a href=\"#\" class=\"refresh-btn js_refresh\"></a>\n\n                    <a href=\"javascript:;\" class=\"sort-btn js_sort\">正序显示</a>\n                </p>\n            </div> -->\n    <div class=\"mod-lineTitle clearfix\" id=\"js_top_time\">\n        <div class=\"left-line fl\"></div>\n        <h4 class=\"title fl\"></h4>\n        <div class=\"right-line fl\"></div>\n    </div>\n\n    <div class=\"js_timelineTop\"></div>\n\n    <div class=\"js_timelineContainer\"></div>\n    <div class=\"mod-showMoreBtn\">\n        <div class=\"mod-loading\"><span></span></div>\n        <a href=\"##\" class=\"w-wide box_more\"><span class=\"w-txt\">点击加载更多</span></a>\n    </div>\n</div>\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.pagelist.pc/app/modules/view/skeleton.ejs
// module id = 442
// module chunks = 0